import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(theme => ({
  root: {
    padding: '2em',
    backgroundColor: theme.palette.grey[200],
    width: '100%'
  },
  paper: {
    padding: '4em',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.05)',
    width: '50%',
    minHeight: 600,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '2em'
    }
  },
  loading: { height: '100vh' },
  buttonSubmit: {
    backgroundColor: theme.palette.success.main,
    color: 'white',
    '&:hover': {
      backgroundColor: theme.palette.success.dark,
    }
  },
  sectionText: {
    marginBottom: '1em'
  }
}))